import { render, staticRenderFns } from "./TeacherTipWrapper.vue?vue&type=template&id=6cce05e8&"
import script from "./TeacherTipWrapper.vue?vue&type=script&lang=js&"
export * from "./TeacherTipWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports